import React, { useState } from "react";
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import SaveIcon from '@mui/icons-material/Save';
import api from "../../api/api";
import ToastMessage from "../../utils/muitoast";
import CloseIcon from '@mui/icons-material/Close';
import dayjs from "dayjs";

const formatHours = (hours) => {
  if (!hours) return '';

  const parts = hours.split(':');
  const hour = parts[0]?.padStart(2, '0') || '00';
  const minute = parts[1]?.padStart(2, '0') || '00';

  return `${hour}:${minute}`;
};
const DateModal = ({ closeModal, passeddata, pickedDate ,fetchData}) => {
    const [editMode, setEditMode] = useState(false);
    const [editedData, setEditedData] = useState([]);
    const [alertmessage, setAlertMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severity, setSeverity] = useState('success');
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
      setOpen(false);
    };

    const handleEditToggle = () => {
      if (!editMode && filteredActivity?.work_details) {
        setEditedData(
          filteredActivity.work_details.map(item => ({
            id: item.id,
            job_id: item.job_id,
              hours: toDecimalHours(item.hours), 
            // hours: item.hours || '',
            perdim: item.perdim || '',
            break: item.break_time || ''
          }))
        );
      }
      setEditMode(!editMode);
    };
    
    const handleChange = (field, value) => {
      setEditedData((prev) => ({ ...prev, [field]: value }));
    };
    
    const handleRowSave = (id) => {
      const updatedRow = editedData.find(row => row.id === id);
      const originalRow = filteredActivity.work_details.find(item => item.id === id);
    
      if (!updatedRow || !originalRow) return;
    
      console.log(`Saving row with ID ${id}`, {
        job_id: originalRow.job_id,
        updatedData: updatedRow,
      });
    
      updatedRowCard(id, updatedRow);
    };
    
      
    
  // Format the pickedDate and compare with activity date
const formatDate = (date) => {
  return dayjs(date).format("MMM D, YYYY");
};

  // Check if pickedDate exists in activity dates
  const filteredActivity = passeddata?.activity?.find((item) => item.date === pickedDate);

  const updatedRowCard=async(id, updatedRow)=>{
      try {
          const response = await api.put(`/v1/timesheets/${id}`,{
          // "clock_in": "10:40:44.721Z",
          // "clock_out": "10:40:44.721Z",
            job_id: updatedRow.job_id,
            break_time:updatedRow.break||0,
            perdim:updatedRow.perdim,
            // hours: formatHours(updatedRow.hours)
                 hours: decimalToHHMM(updatedRow.hours) 
          });
  
          if (response.status === 200) {
              console.log(response.data,'responseData');
               setOpen(true)
               setAlertMessage('Updated Successfully!')
               setSeverity('success')
              setTimeout(() => {
                closeModal()
                fetchData(); 
              }, 2000);
          } else {


              console.log('Error: Response status not 200', response.status);
          }
      } catch (error) {
          console.error('Error fetching data:', error);
      } finally {
        // setTableLoading(false)
      }

  }
const toDecimalHours = (timeStr) => {
  if (!timeStr) return 0;
  const [h, m] = timeStr.split(":").map(Number);
  return +(h + m / 60).toFixed(2); // round to 2 decimals
};

// Convert Decimal → HH:MM (ignore seconds)
const decimalToHHMM = (decimal) => {
  if (decimal === '' || isNaN(decimal)) return "00:00";
  const hours = Math.floor(decimal);
  const minutes = Math.round((decimal - hours) * 60);
  return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
};

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50 ">
<div className={`bg-white rounded-lg shadow-lg  ${filteredActivity?.work_details?.length === 1 ? 'w-[40%]' : 'w-[70%]'}  p-6 relative`}>
<ToastMessage message={alertmessage} severity={severity} open={open} handleClose={handleClose} />

<div className="flex flex-col items-center border-b pb-3">
          <div className='flex w-full justify-between'>
            <div className="flex">
            <h3 className="text-xl text-red-800 font-semibold font-inter">{passeddata?.emp_name}</h3>
            <div  onClick={handleEditToggle} className="ml-2 px-1 border-2 cursor-pointer border-[#ccc] rounded-full flex items-center justify-center">
  <ModeEditIcon className="text-gray-500" style={{ width: '16px', height: '16px' }} />
</div>

            </div>
            <button onClick={closeModal} className="text-xl font-bold"><CloseIcon/></button>
          </div>
          <div className='flex gap-1 w-full flex-start font-semibold  font-Font1'>
            <span>{formatDate(pickedDate)}</span> 
          </div>
        </div>
        <div className="mt-4  max-h-[80vh] overflow-y-auto">
          {/* Render userdetails if passeddata exists */}
          {passeddata && Object.keys(passeddata).length > 0 ? (
            <div>
              {/* Show name if available */}
             
              {/* Display activity data if there's a match */}
              {filteredActivity ? (
                <div className="mt-4">
                           <div className={`grid grid-flow-row gap-4 ${filteredActivity.work_details.length === 1 ? 'grid-cols-1' : 'grid-cols-2'}`}>
                  {filteredActivity.work_details && filteredActivity.work_details.length > 0 ? (
                    filteredActivity.work_details.map((workItem, index) => (
                        <div key={index} className="border p-4 rounded-lg shadow-sm bg-gray-100">
                        <div className="flex items-center gap-2 my-2">
                          <div className="font-Font1 font-semibold text-md text-red-800"> {passeddata?.emp_name}</div> 
                         
                        </div>

                        <div className="flex items-center justify-between gap-2 my-2">
                          <div className="font-inter font-semibold text-sm text-red-800 text-left">Job:  <span className='font-normal text-[black]'>{workItem.jobDescription}</span></div> 
                          <div className='px-2 py-1 rounded-xl text-sm bg-red-200 rounded'>{workItem.job_id}</div>
                        </div>

                        <div className="flex items-center justify-between gap-4 pb-4 border-b my-2">
                          <div className="font-inter font-semibold text-sm text-red-800 text-left">Cost: <span className='font-normal text-[black]'>{workItem.costcodeDescription}</span></div> 
                          <div className='px-2 py-1 rounded-xl text-sm bg-red-200 rounded'>{workItem.cost_code_id}.00</div>
                        </div>
                        <div className='flex justify-between border-b pb-1 mb-1'>
                          <div className="flex items-center flex-col gap-4">
  <div className="font-inter text-gray-500 text-sm">Clock In</div> 
  {new Date(workItem.clock_in).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
                </div>

<div className="flex items-center flex-col gap-4">
  <div className="font-inter text-gray-500 text-sm">Clock Out</div> 
  {new Date(workItem.clock_out).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false })}
</div>


                            <div className="flex items-center flex-col gap-4">
                              <div className="font-inter text-gray-500 text-sm ">Break</div> 
                              {workItem.break_time >= 60
    ? `${(workItem.break_time / 60).toFixed(1)} hrs`
    : `${workItem.break_time} mins`}
                              </div>
                          </div>
                        <div className='flex justify-between'>
                        <div className="flex items-center flex-col gap-2">
                            <div className="font-inter text-gray-500 text-sm ">Per Diem</div> 
                            ${workItem.perdim}
                          </div>
                          {/* <div className="flex items-center flex-col gap-2 ml-8">
                            <div className="font-inter text-gray-500 text-sm ">Overtime</div> 
                            {workItem.perdim}
                          </div> */}
                     

                          <div className="flex items-center flex-col gap-2">
                            <div className="font-inter text-gray-500 text-sm ">Total Hours</div> 
                {toDecimalHours(workItem.hours)} hrs
                          </div>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No data found.</p>
                  )}
                  </div>
                </div>
              ) : (
                <p>No data found.</p>
              )}
            </div>
          ) : (
            <p>No data found</p>
          )}
             <div className="w-full">
        {editMode && editedData.length > 0 && (
          <div className="mt-4 border-t pt-3">
  <table className="w-full text-sm border border-gray-300 rounded overflow-hidden table-fixed">
    <thead className="bg-gray-100 text-left text-gray-700">
      <tr>
        <th className="p-2 text-red-800 text-center w-[15%]">Job</th>
        <th className="p-2 text-red-800 text-center w-[20%]">Hours (HH:MM)</th>
        <th className="p-2 text-red-800 text-center w-[20%]">Per Diem ($)</th>
        <th className="p-2 text-red-800 text-center w-[20%]">Break (Mins)</th>
        <th className="p-2 text-red-800 text-center w-[10%]">Actions</th>
      </tr>
    </thead>
    <tbody>
      {editedData.map((row) => {
        const workDetail = filteredActivity.work_details.find(w => w.id === row.id);

        return (
          <tr key={row.id} className="border-t">
            <td className="p-2 align-middle">{workDetail?.job_id}</td>

            {/* <td className="p-2">
              <input
                type="text"
                value={row.hours}
                onChange={(e) => {
                  setEditedData(prev =>
                    prev.map(r => r.id === row.id ? { ...r, hours: e.target.value } : r)
                  );
                }}
                className="border px-2 py-1 rounded w-full text-center"
                placeholder="HH:MM"
              />
            </td> */}
<td className="p-2">
  <input
    type="number"
    step="0.01"
    value={row.hours}
    onChange={(e) => {
      const val = e.target.value;
      setEditedData(prev =>
        prev.map(r => r.id === row.id ? { ...r, hours: val } : r)
      );
    }}
    className="border px-2 py-1 rounded w-full text-center"
    placeholder=""
  />
</td>
            <td className="p-2">
              <input
                type="text"
                value={row.perdim}
                onChange={(e) => {
                  setEditedData(prev =>
                    prev.map(r => r.id === row.id ? { ...r, perdim: e.target.value } : r)
                  );
                }}
                className="border px-2 py-1 rounded w-full text-center"
                placeholder="$"
              />
            </td>

            <td className="p-2">
              <input
                type="text"
                value={row.break}
                onChange={(e) => {
                  setEditedData(prev =>
                    prev.map(r => r.id === row.id ? { ...r, break: e.target.value } : r)
                  );
                }}
                className="border px-2 py-1 rounded w-full text-center"
                placeholder="0"
              />
            </td>

            <td className="p-2 text-center">
              <SaveIcon
                onClick={() => handleRowSave(row.id)}
                className="cursor-pointer hover:text-green-700"
                style={{ fontSize: '24px' }}
              />
            </td>
          </tr>
        );
      })}
    </tbody>
  </table>
</div>

)}

         </div>
        </div>
    
      </div>
    </div>
  );
};

export default DateModal;
